import axios from "axios";
import { isValidUriString } from "functions/isValidUriString";
import { LoaderFunctionArgs, redirect } from "react-router-dom";
import { REACT_APP_BACKENDURL } from "../../../config";
import { defaultSettings } from "../../../contexts/appsettings/defaultSettings";
import { getTlfUrl } from "../../../contexts/tlf/getTlfUrl";
import { loadHierarchy } from "../hierarchy/loadHierarchy";

/**
 * Loader that redirects old-style TLF URLs to the canonical TLF route.
 *
 * @param props - Loader args from react-router
 * @param props.params - Route params identifying the TLF
 * @param props.request - The fetch request for the current navigation
 * @returns A redirect response for the canonical TLF URL or NotFound
 */
export const tlfRedirectLoader = async ({ params, request }: LoaderFunctionArgs) => {
  const backEndUrl = REACT_APP_BACKENDURL.includes("_REACT_APP_BACKENDURL_")
    ? defaultSettings.backEndUrl
    : REACT_APP_BACKENDURL;

  const url = params.id
    ? `${backEndUrl}TlfItems/ById/${params.id}${params.azsolId && isValidUriString(params.azsolId) ? `/${params.azsolId}` : ""}`
    : params.azsolId !== undefined && params.version !== undefined
      ? `${backEndUrl}TlfItems/${params.azsolId}/${params.version}`
      : undefined;

  if (url) {
    // Get TLF item
    const tlfLoader = await axios.get(url);
    const tlfItem = tlfLoader.data;
    /* istanbul ignore else */
    if (tlfItem?.primaryHierarchyId !== undefined) {
      // Get Hierarchy
      const hierarchyRequest = await loadHierarchy(backEndUrl, {
        hierarchyId: tlfItem.primaryHierarchyId,
      });
      // Redirect
      /* istanbul ignore else */
      if (hierarchyRequest.success) {
        const requestUrl = new URL(request.url);
        const redirectTo = requestUrl.origin + `${getTlfUrl(hierarchyRequest.data, tlfItem)}`;
        const redirectUrl = new URL(redirectTo);
        // Add search params if available
        const searchParams = new URLSearchParams(requestUrl.search);
        /* istanbul ignore else */
        if (searchParams !== undefined) redirectUrl.search = searchParams.toString();
        return redirect(redirectUrl.toString());
      }
    }
  }
  return redirect("/NotFound");
};
